<template>
	<div
		class="ds-left-menu"
		:style="{ width: isCollapse ? '64px' : '240px' }"
	>
		<div
			class="top-compyan-box"
			:class="isCollapse ? 'top-compyan-cener' : ''"
		>
			<div class="ds-logo-img">
				
				<span>途灵物流</span>
			</div>
			<i
				@click="changeCollapse"
				style="font-size: 25px; color: #ffffff"
				class="el-icon-menu"
			></i>
		</div>

		<div class="bottom-scroll">
			<el-menu
				:collapse="isCollapse"
				background-color="#212844"
				text-color="#ffffff"
				active-text-color="#409EFF"
				:default-active="
                    activeHistoryTabItem ? activeHistoryTabItem.activeIndex : ''
                "
				class="ds-el-menu"
			>
				<template v-for="(item, itemIndex) in menuList">
					<el-submenu
						:key="item.id"
						v-if="!item.hideMenu"
						:index="`${itemIndex}`"
					>
						<template slot="title">
							<i :class="item.meta.icon"></i>
							<span
								slot="title"
								v-text="item.meta.title"
							></span>
						</template>

						<template v-for="(childItem, childItemIndex) in item.children">
							<el-menu-item
								@click="
                                    goRouter(
                                        childItem,
                                        `${itemIndex}-${childItemIndex}`
                                    )
                                "
								v-if="!childItem.hideMenu"
								:key="childItem.id"
								:index="`${itemIndex}-${childItemIndex}`"
							>
								<template slot="title">
									<i :class="childItem.meta.icon"></i>
									<span
										slot="title"
										v-text="childItem.meta.title"
									></span>
								</template>
							</el-menu-item>
						</template>
					</el-submenu>
				</template>
			</el-menu>
		</div>
	</div>
</template>

<script>
let menuChange = new CustomEvent("menu_size_change", {
	detail: {},
});
import { baseUrl } from "../utils/http";
export default {
	components: {},
	data() {
		return {
			isCollapse: false,
		};
	},
	computed: {
		menuList() {
			return this.$store.state.app.menuList;
		},
		activeHistoryTabItem() {
			return this.$store.state.app.activeHistoryTabItem;
		},
	},

	methods: {
		changeCollapse() {
			this.isCollapse = !this.isCollapse;
			setTimeout(() => {
				window.dispatchEvent(menuChange);
			}, 500);
		},
		goRouter(item, activeIndex) {
			this.$router.replace({
				name: item.name,
			});
			this.$store.dispatch("app/addHistoryTopTabMenu", {
				...item,
				activeIndex: activeIndex,
			});
		},
	},
};
</script>


<style lang='scss'>
.ds-left-menu {
	height: 100%;
	background: #212844;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	will-change: width;
	transition: width 350ms;
	.bottom-scroll {
		flex: 1;
		overflow: hidden;
		overflow-y: auto;
		background: #212844;
		position: relative;
	}

	.top-compyan-box {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 65px;
		overflow: hidden;
		.ds-logo-img {
			margin-left: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			background: #ffffff;
			width: 190px;
			height: 42px;
			border-radius: 5px;
			overflow: hidden;
			img {
				width: 60px;
				height: auto;
				display: block;
			}
			span {
				display: block;
				font-size: 18px;
				font-weight: bold;
				color: #409EFF;
			}
		}
		.ds-menu-button {
			color: #ffffff;
			font-size: 30px;
		}
	}
	.top-compyan-cener {
		justify-content: center;
		.ds-logo-img {
			display: none;
		}
	}
	.ds-el-menu {
		border-right: 0px;
	}
}
</style>